import React from "react";
import { Table, TableHead, TableCell, TableRow, TableBody } from "@material-ui/core";
import { Values } from "Tools/Values";
import PositionTeamTableItem from "./PositionTeamTableItem/PositionTeamTableItem";
import { STPaper } from "@src/Components/Ui/STPaperOverflow";
import { STTableHeadTypography } from "@src/Components/Ui/STTableHeadTypography";
import { PositionTeam } from "@src/Interfaces/Entity/PositionTeam";
import { inject } from "mobx-react";
import { IAuthStore } from "@src/Stores/Auth/types";

interface IProps {
  positionTeams: PositionTeam[];
  onEditButtonClick: (positionTeam: PositionTeam) => void
  auth?: IAuthStore;
}

@inject("auth")
export default class PositionTeamsTable extends React.Component<IProps> {
  render() {
    return (
      <STPaper elevation={2}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("name")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("description")}</STTableHeadTypography>
              </TableCell>
              {!this.props.auth.user.location.primary && (
                <TableCell>
                  <STTableHeadTypography>{Values.getLocalizationValue("members")}</STTableHeadTypography>
                </TableCell>
              )}
              <TableCell align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.positionTeams.map((positionTeam: PositionTeam) => (
                <PositionTeamTableItem
                    key={positionTeam.id}
                    positionTeam={positionTeam}
                    onEditButtonClick={() => this.props.onEditButtonClick(positionTeam)}
                />
            ))}
          </TableBody>
        </Table>
      </STPaper>
    );
  }
}
